<template>
    <tr>
        <td class="text-center" v-if="showImage">
            <img :src="listItem.item.item_picture_medium" class="product_image_print" />
        </td>
        <td class="text-left">
            <div class="item-info">
                <h2 class="product_row-title title-s">{{ listItem.item.item_name }}</h2>
                <p class="product_row-size paragraph-details">
                    {{listItem.item.formattedVariants}}
                </p>
            </div>
        </td>
        <td class="text-center">
            #{{ listItem.item_no }}
        </td>
        <td v-if="canSeePricing" class="text-center">
            {{ listItem.formattedPrice }}
        </td>
        <td class="text-center">
            {{listItem.quantity}}
        </td>
        <td v-if="canSeePricing" class="text-center">
            {{ listItem.formattedSubtotal }}
        </td>
    </tr>
</template>
<script lang="ts" setup>
    import { computed } from "vue";
    import { useCartDetails } from "@/helpers/composables/useCartDetails";
    import CarbonShoppingCartError from "@icons/carbon_shopping-cart-error.svg";
    import { useSettingsStore } from "@/store/settings";
    import { storeToRefs } from "pinia";
    const settings = useSettingsStore();
    const { canSeePricing } = storeToRefs(settings);
    let props = defineProps({
        list_item: {
            type: Object<any>,
            default: {}
        },
        readonly: {
            type: Boolean,
            default: false
        },
        show_image: {
            type: Boolean
        }
    });

    const list_item = computed(()=>{
        return props.list_item;
    });

    const showImage = computed(()=>{
        return props.show_image;
    });

    let { listItem } = useCartDetails(list_item);

    const outOfStock = computed(() => {
        return listItem.value.item.inventory_level < listItem.value.quantity;
    });
</script>
